/**
 * @generated SignedSource<<7a816bb6134ffc8c044d7cea3fec5732>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoryReaderQuery$variables = {
  bookId: string;
  language: string;
};
export type StoryReaderQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly storyBook: {
        readonly coverImage: string;
        readonly gloss: string | null | undefined;
        readonly id: string;
        readonly pages: ReadonlyArray<{
          readonly gloss: string | null | undefined;
          readonly id: string;
          readonly listenPassage: {
            readonly firstPage: number;
          } | null | undefined;
          readonly number: number;
          readonly picture: string | null | undefined;
          readonly sayWithMe: boolean;
          readonly text: string;
        }>;
        readonly title: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type StoryReaderQuery = {
  response: StoryReaderQuery$data;
  variables: StoryReaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "language",
      "variableName": "language"
    }
  ],
  "kind": "ScalarField",
  "name": "gloss",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "bookId"
    }
  ],
  "concreteType": "StoryBook",
  "kind": "LinkedField",
  "name": "storyBook",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverImage",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "picture",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sayWithMe",
          "storageKey": null
        },
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ListenPassage",
          "kind": "LinkedField",
          "name": "listenPassage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoryReaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StoryReaderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ca5fb27256e43fb987bf8d3d83823c7d",
    "id": null,
    "metadata": {},
    "name": "StoryReaderQuery",
    "operationKind": "query",
    "text": "query StoryReaderQuery(\n  $bookId: ID!\n  $language: String!\n) {\n  me {\n    learner {\n      defaultCharacter {\n        audience\n        id\n      }\n      storyBook(id: $bookId) {\n        id\n        title\n        coverImage\n        gloss(language: $language)\n        pages {\n          id\n          number\n          text\n          picture\n          sayWithMe\n          gloss(language: $language)\n          listenPassage {\n            firstPage\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "84c99a3cc9e505c81a8cfaf43ca88419";

export default node;
